import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/ico_no_races.svg?url_encode")